<template>
  <div>
    <div class="w-100 d-flex justify-content-end my-1">
      <b-button
        class="mr-1"
        variant="outline-success"
        @click="openModal({}, 'create')"
      >
        <div class="d-flex justify-content-between">
          <span> {{ $t("CREATE") }} </span>
        </div>
      </b-button>
    </div>

    <filter-slot
      :filter="[]"
      :filterPrincipal="filterPrincipal"
      :paginate="paginate"
      :no-visible-principal-filter="true"
      @reload="refreshTable"
    >
      <template #table>
        <b-table
          ref="reft-variable-bonus-table"
          :per-page="paginate.perPage"
          :current-page="paginate.currentPage"
          sticky-header="50vh"
          small
          class="position-relative"
          :busy.sync="isBusy"
          :items="myProvider"
          :fields="fields"
          primary-key="id"
        >
          <template #table-busy>
            <b-skeleton-table
              :headers="fields"
              :rows="paginate.perPage"
              :columns="fields.length"
              :table-props="{ bordered: true, striped: true }"
            />
          </template>

          <template #cell(monto)="data">
            <span>S/. {{ parseFloat(data.item.monto).toFixed(2) }}</span>
          </template>

          <template #cell(actions)="data">
            <div class="d-flex align-items-center">
              <feather-icon
                icon="EditIcon"
                v-b-tooltip.hover.left="$t('Edit')"
                class="text-warning cursor-pointer ml-1"
                size="18"
                @click="openModal(data.item, 'edit')"
              />
              <feather-icon
                icon="ActivityIcon"
                v-b-tooltip.hover.left="$t('Audit Trail')"
                class="text-info cursor-pointer ml-2"
                size="18"
                @click="openTrackingModal(data.item)"
              />
              <feather-icon
                icon="Trash2Icon"
                v-b-tooltip.hover.left="$t('Delete')"
                class="text-danger cursor-pointer ml-2"
                size="18"
                @click="deleteItem(data.item)"
              />
            </div>
          </template>
        </b-table>
      </template>
    </filter-slot>

    <AddVariableBonusModal
      v-if="showModal"
      :bonus="currentBonus"
      :method="method"
      @close="showModal = false"
      @saved="closeRefresh"
    />

    <!-- Modal for Tracking History -->
    <b-modal
      ref="tracking-modal"
      hide-footer
      size="xl"
      :title="`${$t('Audit Trail')} - ${$t('History')}`"
    >
      <div class="p-1">
        <b-table
          :items="trackingData"
          :fields="trackingFields"
          responsive
          striped
          hover
          small
        >
          <template #cell(action)="data">
            <b-badge :variant="getActionBadge(data.item.action)">
              {{ data.item.action }}
            </b-badge>
          </template>
          <template #cell(monto)="data">
            <span>S/. {{ parseFloat(data.item.monto).toFixed(2) }}</span>
          </template>
          <template #cell(created_at)="data">
            <span>{{ new Date(data.item.created_at).toLocaleString() }}</span>
          </template>
        </b-table>
        <div v-if="trackingData.length === 0" class="text-center my-3 text-muted">
          {{ $t("No history found") }}
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import FilterSlot from "@/views/commons/filter-slot/FilterSlot.vue";
import SettingVariableBonusService from "@/views/settings/views/payroll/components/variable-bonus/service/setting-variable-bonus.service.js";
import AddVariableBonusModal from "@/views/settings/views/payroll/components/variable-bonus/AddVariableBonusModal.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    FilterSlot,
    AddVariableBonusModal,
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
    fields() {
      return [
        {
          key: "categoria",
          sortable: true,
          label: this.$t("Category"),
        },
        {
          key: "tipo_vehiculo",
          sortable: true,
          label: this.$t("Vehicle Type"),
        },
        {
          key: "tipo_servicio",
          sortable: true,
          label: this.$t("Service Type"),
        },
        {
          key: "servicio",
          sortable: true,
          label: this.$t("Service"),
        },
        {
          key: "destino",
          sortable: true,
          label: this.$t("Destination"),
        },
        {
          key: "monto",
          sortable: true,
          label: this.$t("Amount"),
        },
        {
          key: "actions",
          label: this.$t("actions"),
        },
      ];
    },
    trackingFields() {
      return [
        { key: "created_at", label: this.$t("Date/Time") },
        { key: "action", label: this.$t("Action") },
        { key: "user_name", label: this.$t("User") },
        { key: "categoria", label: this.$t("Category") },
        { key: "tipo_vehiculo", label: this.$t("Vehicle Type") },
        { key: "tipo_servicio", label: this.$t("Service Type") },
        { key: "servicio", label: this.$t("Service") },
        { key: "destino", label: this.$t("Destination") },
        { key: "monto", label: this.$t("Amount") },
      ];
    },
  },
  data() {
    return {
      showModal: false,
      method: "create",
      currentBonus: null,
      isBusy: false,
      paginate: {
        from: 0,
        to: 0,
        of: 0,
        perPage: 10,
        currentPage: 1,
      },
      filterPrincipal: {
        type: "input",
        inputType: "text",
        placeholder: "SEARCH...",
        model: "",
      },
      trackingData: [],
    };
  },
  methods: {
    async myProvider(ctx) {
      try {
        let order = "id";
        switch (ctx.sortBy) {
          case "categoria":
            order = "categoria";
            break;
          case "tipo_vehiculo":
            order = "tipo_vehiculo";
            break;
          case "tipo_servicio":
            order = "tipo_servicio";
            break;
          case "servicio":
            order = "servicio";
            break;
          case "destino":
            order = "destino";
            break;
          case "monto":
            order = "monto";
            break;
          default:
            order = "id";
            break;
        }

        const params = {
          page: ctx.currentPage,
          perpage: ctx.perPage,
          order: order,
          orderby: ctx.sortDesc ? "desc" : "asc",
          search_txt: this.filterPrincipal.model,
        };

        const data = await SettingVariableBonusService.list(params);
        this.paginate.from = data.from;
        this.paginate.to = data.to;
        this.paginate.of = data.total;
        this.paginate.perPage = data.per_page;
        this.paginate.currentPage = data.current_page;
        return data.data;
      } catch (error) {
        console.error(error);
        this.showToastError(error?.response?.data?.message || error.message);
      }
    },

    openModal(item, type) {
      this.currentBonus = item;
      this.method = type;
      this.showModal = true;
    },

    async openTrackingModal(item) {
      try {
        this.addPreloader();
        const data = await SettingVariableBonusService.tracking({
          configuracion_bono_id: item.id,
        });
        this.trackingData = data;
        this.$refs["tracking-modal"].show();
      } catch (error) {
        console.error(error);
        this.showToastError(error?.response?.data?.message || error.message);
      } finally {
        this.removePreloader();
      }
    },

    getActionBadge(action) {
      switch (action) {
        case "CREATED":
          return "success";
        case "UPDATED":
          return "warning";
        case "DELETED":
          return "danger";
        default:
          return "secondary";
      }
    },

    closeRefresh() {
      this.showModal = false;
      this.refreshTable();
    },

    refreshTable() {
      this.$refs["reft-variable-bonus-table"].refresh();
    },

    async deleteItem(item) {
      const confirm = await this.showConfirmSwal(
        this.$t("Are you sure?"),
        this.$t("You won't be able to revert this!")
      );
      if (!confirm.isConfirmed) return;

      try {
        this.addPreloader();
        const params = {
          id: item.id,
          user_id: this.currentUser ? this.currentUser.id : null,
        };
        const data = await SettingVariableBonusService.delete(params);
        this.showToastSuccess(data.message);
        this.refreshTable();
      } catch (error) {
        console.error(error);
        this.showToastError(error?.response?.data?.message || error.message);
      } finally {
        this.removePreloader();
      }
    },
  },
};
</script>

<style>
</style>
